// app/javascript/packs/comment.js
import $ from "jquery";

function getCommentIdFromModal(modalEl) {
  if (!modalEl || !modalEl.id) return null;
  // exampleModal-123 or editModal-123
  const parts = modalEl.id.split("-");
  return parts[1] || null;
}

function ensureHiddenInputs(modalEl, type, commentId) {
  const form = modalEl.querySelector("form");
  if (!form || !commentId) return [null, null, null];

  function resolveOrCreate(idPreferred, idAlternate, name) {
    let el =
      document.getElementById(idPreferred) ||
      document.getElementById(idAlternate);
    if (!el) {
      el = document.createElement("input");
      el.type = "file";
      el.name = name;
      el.id = idPreferred; // create with preferred ID
      el.className = "d-none";
      form.appendChild(el);
    }
    return el;
  }

  const el1 = resolveOrCreate(
    `${type}_image_s3_hidden_${commentId}`,
    `image_s3_hidden_${type}_${commentId}`,
    "comment[image_s3]"
  );
  const el2 = resolveOrCreate(
    `${type}_image_s3_hidden_2_${commentId}`,
    `image_s3_hidden_2_${type}_${commentId}`,
    "comment[image_s3_2]"
  );
  const el3 = resolveOrCreate(
    `${type}_image_s3_hidden_3_${commentId}`,
    `image_s3_hidden_3_${type}_${commentId}`,
    "comment[image_s3_3]"
  );

  return [el1, el2, el3];
}

function updateHiddenFields(commentId, files, type, modalEl) {
  if (!commentId || !files) return;
  const [el1, el2, el3] = ensureHiddenInputs(modalEl, type, commentId);

  [el1, el2, el3].forEach((el) => {
    if (el) el.files = new DataTransfer().files;
  });

  if (files.length > 0) {
    const dts = [new DataTransfer(), new DataTransfer(), new DataTransfer()];
    if (files[0]) dts[0].items.add(files[0]);
    if (files[1]) dts[1].items.add(files[1]);
    if (files[2]) dts[2].items.add(files[2]);

    const els = [el1, el2, el3];
    els.forEach((el, idx) => {
      if (el) el.files = dts[idx].files;
    });
  }
}

function appendPreview(modalEl, file, commentId, type) {
  const reader = new FileReader();
  reader.onload = function (e) {
    const imageHtml = `
      <div class="current-image-container position-relative d-inline-block me-2 mb-2" data-new-image="true">
        <img src="${e.target.result}" class="rounded border" style="max-width: 120px; max-height: 120px; object-fit: cover;">
        <button type="button" class="btn btn-sm btn-danger position-absolute top-0 end-0" style="transform: translate(50%, -50%);" onclick="removeNewImage(${commentId}, '${type}', this)">
          <i class="fa fa-times"></i>
        </button>
      </div>
    `;

    // Append into the correct preview container depending on type
    const previewContainerSelector =
      type === "edit"
        ? `#edit-preview-container-${commentId}`
        : `#reply-preview-container-${commentId}`;

    const previewContainer = $(modalEl).find(previewContainerSelector);
    if (previewContainer.length > 0) {
      previewContainer.append(imageHtml);
    }
  };
  reader.readAsDataURL(file);
}

function handleFilesChange(inputEl, type) {
  const modalEl = $(inputEl).closest(".modal")[0];
  const commentId = getCommentIdFromModal(modalEl);
  if (!modalEl || !commentId) return;

  const files = inputEl.files;
  if (files.length === 0) return;

  // Show the right preview container and clear previous previews
  if (type === "edit") {
    $(`#edit-image-preview-${commentId}`).removeClass("d-none");
    $(`#edit-preview-container-${commentId}`).empty();
  } else {
    $(`#reply-image-preview-${commentId}`).removeClass("d-none");
    $(`#reply-preview-container-${commentId}`).empty();
  }

  const maxFiles = Math.min(files.length, 3);
  for (let i = 0; i < maxFiles; i++) {
    appendPreview(modalEl, files[i], commentId, type);
  }
  updateHiddenFields(commentId, files, type, modalEl);
}

// Expose functions used by inline onclick in ERB
window.removeCurrentImage = function (commentId, imageUrl) {
  if (!confirm("この画像を削除しますか？")) return;

  const modal =
    document.querySelector(`#exampleModal-${commentId}`) ||
    document.querySelector(`#editModal-${commentId}`);
  if (!modal) return;

  const form = modal.querySelector("form");
  if (!form) return;

  const hiddenField = document.createElement("input");
  hiddenField.type = "hidden";
  hiddenField.name = "comment[removed_images][]";
  hiddenField.value = imageUrl;
  form.appendChild(hiddenField);

  const img = modal.querySelector(
    `.current-image-container img[src="${imageUrl}"]`
  );
  if (img) {
    const container = img.closest(".current-image-container");
    if (container) container.remove();
  }

  const remaining = modal.querySelectorAll(".current-image-container");
  if (remaining.length === 0) {
    const currentImages = modal.querySelector(".current-images");
    if (currentImages) currentImages.classList.add("d-none");
  }

  showNotification("画像が削除されました", "success");
};

window.removeEditImage = function (commentId, index) {
  const input = document.querySelector(
    `#editModal-${commentId} input[name$="[images_s3]"]`
  );
  if (!input) return;

  const dt = new DataTransfer();
  const { files } = input;
  for (let i = 0; i < files.length; i++) {
    if (i !== index) dt.items.add(files[i]);
  }
  input.files = dt.files;

  if (input.files.length === 0) {
    $(`#edit-image-preview-${commentId}`).addClass("d-none");
  } else {
    $(input).trigger("change");
  }
};

window.removeNewImage = function (commentId, type, button) {
  const imageContainer = button.closest(".current-image-container");
  if (imageContainer) imageContainer.remove();

  const modal = document.querySelector(`#${type}Modal-${commentId}`);
  if (!modal) return;

  const input = modal.querySelector('input[name$="[images_s3]"]');
  if (input && input.files.length > 0) {
    const dt = new DataTransfer();
    const { files } = input;

    const remainingImages = modal.querySelectorAll(
      `.current-image-container[data-new-image="true"]`
    );
    const remainingCount = remainingImages.length;

    for (let i = 0; i < Math.min(files.length, remainingCount); i++) {
      dt.items.add(files[i]);
    }
    input.files = dt.files;
    updateHiddenFields(commentId, input.files, type, modal);
  }

  const allImages = modal.querySelectorAll(".current-image-container");
  if (allImages.length === 0) {
    if (type === "edit") {
      $(`#edit-image-preview-${commentId}`).addClass("d-none");
    } else {
      $(`#reply-image-preview-${commentId}`).addClass("d-none");
    }
  }
};

function showNotification(message, type = "info") {
  const notification = document.createElement("div");
  notification.className = `alert alert-${
    type === "success" ? "success" : "info"
  } position-fixed`;
  notification.style.cssText =
    "top: 20px; right: 20px; z-index: 9999; min-width: 300px;";
  notification.innerHTML = `
    <div class="d-flex align-items-center gap-2">
      <i class="fa fa-${
        type === "success" ? "check-circle" : "info-circle"
      }"></i>
      <span>${message}</span>
      <button type="button" class="btn-close ms-auto" onclick="this.parentElement.remove()"></button>
    </div>
  `;
  document.body.appendChild(notification);
  setTimeout(() => {
    if (notification.parentElement) notification.remove();
  }, 3000);
}

$(document).on("turbolinks:load", function () {
  $(document).off("change", '[id^="exampleModal-"] input[type="file"][name*="[images_s3]"]');
  $(document).off("change", '[id^="editModal-"] input[type="file"][name*="[images_s3]"]');
  
  // Reply modal: listen only to main multi file input (images_s3)
  $(document).on(
    "change",
    '[id^="exampleModal-"] input[type="file"][name*="[images_s3]"]',
    function (e) {
      if (e.isDefaultPrevented()) return;
      e.preventDefault();
      handleFilesChange(this, "reply");
    }
  );

  // Edit modal: listen only to main multi file input (images_s3)
  $(document).on(
    "change",
    '[id^="editModal-"] input[type="file"][name*="[images_s3]"]',
    function (e) {
      if (e.isDefaultPrevented()) return;
      e.preventDefault();
      handleFilesChange(this, "edit");
    }
  );
});
